<template lang="pug">
div(class="tl-code code")
    pre(
        :class="'language-' + lang"
        :lang="lang"
        class="prism"
    )
        code {{ code }}
</template>

<script setup>
import Prism from 'prismjs'
import { computed, onMounted, watch, inject } from 'vue'
import '../plugins/prism'
import { isClient } from '@vueuse/core'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    lang: {
        type: String,
        default: 'html',
    },
    code: String,
})

const injects = getInjects(props, inject)

const decode = (html) => {
    if (isClient) {
        if (!html) return false
        const d = document.createElement('div')
        d.innerHTML = html
        return d.childNodes[0].nodeValue
    }
    return undefined
}

const code = computed(() => decode(props.code) ?? decode(injects.code?.value) ?? null)
const lang = computed(() => props.lang ?? injects.lang?.value ?? 'html')

watch(code, () => {
    Prism.highlightAll()
})

onMounted(() => {
    if (isClient) {
        Prism.highlightAll()
    }
})
</script>

<style>
@media print {
    .line-highlight {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

.line-highlight {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}
</style>
